module.exports = __webpack_public_path__ + "img/aeroland-client-logo-12.0c4fcd8b.png";